module.exports = __webpack_public_path__ + "img/session2_card_icon1.6e60f979.png";